import React, { Component } from 'react'
import { Button, Card, Dropdown, Form, Icon, Tab } from 'semantic-ui-react'
import { languages } from '../../../../constants'
import Images from './time/images'
import Details from './time/details'
import Schedules from './time/schedules'
import { createTranslationsObject } from '../../../../helpers/translation'
import { convertGraphQlToObject } from '../../../../helpers/contentWithI18n'

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = {obj: obj, language: language, onChange: onChange}
    return {menuItem: language.label, render: () => <Tab.Pane key={language.code} attached={false}><Details {...attrs} /></Tab.Pane>}
  })

  panes.push({menuItem: 'Gestion des images', render: () => <Tab.Pane attached={false}><Images obj={obj} onChange={onChange} /></Tab.Pane>})
  panes.push({menuItem: 'Horaires', render: () => <Tab.Pane attached={false}><Schedules obj={obj} onChange={onChange} /></Tab.Pane>})

  return panes
}

const renderPlaces = (places) => {
  let _places = [{ value: null, text: '--' }]
  places.forEach(place => {
    _places.push({value: place.id, text: place.name})
  })
  return _places
}

class IntroBlock extends Component {
  constructor (props) {
    super(props)

    this.state = {
      obj: {
        id: null,
        type: 'time_block',
        img_desktop: null,
        img_mobile: null,
        opening: {},
        phone: '',
        place_id: null,
        translations: createTranslationsObject({
          schedules: '',
          cta_label: '',
          cta_url: ''
        })
      }
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentWillMount() {
    if (this.props.obj) {
      const obj = convertGraphQlToObject(this.props.obj)
      const newObj = {...this.state.obj}

      newObj.id = obj.id
      newObj.img_desktop = obj.img_desktop
      newObj.img_mobile = obj.img_mobile
      newObj.opening = obj.opening
      newObj.place_id = (obj.place) ? (typeof obj.place  === 'object') ? obj.place.id : obj.place : null
      newObj.phone = obj.phone
      newObj.translations = obj.translations

      this.setState({
        obj: newObj
      })
    }
  }

  handleChange (event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
        opening: {
          ...this.state.obj.opening
        }
      }
    }
    let dataIsLanguage = false
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true
      }
    }

    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value
    } else if (typeof data === 'object' && data.id.indexOf('opening') !== -1) {
      const keys = data.id.match(/(\w+)/g)
      if (keys !== null && keys.length === 3) {
        if (!newState.obj.opening[keys[1]]) {
          newState.obj.opening[keys[1]] = {}
        }

        newState.obj.opening[keys[1]][keys[2]] = data.value
      }
    } else if (type === 'dropdown' || type === 'image') {
      //dropdown or image
      newState.obj[data.id] = data.value
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value
    }

    this.setState(newState)
  }

  getValues = () => {
    return this.state.obj
  }

  render () {
    const { onDelete, places } = this.props

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            Bloc horaires
            <Button type='submit' size='mini' color='red' floated='right' icon onClick={onDelete}>
              <Icon name="delete" />
            </Button>
            {/* {index !== max - 1 && <Button size='mini' floated='right' icon onClick={(e) => { onMoveBlock('down', index) }}><Icon name="arrow down" /></Button>}
            {index !== 0 && <Button size='mini' floated='right' icon onClick={(e) => { onMoveBlock('up', index) }}><Icon name="arrow up" /></Button>} */}
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <Card.Description>
            <Form.Field>
              <label>Emplacement</label>
              {
                places.loading ? <div>Chargement des emplacements</div> :
                  <Dropdown placeholder='Sélectionnez un emplacement' fluid selection closeOnChange id='place_id' value={this.state.obj.place_id} options={renderPlaces(places.getPlaces)} onChange={(e, data) => this.handleChange(e, data, 'dropdown')} />
              }
            </Form.Field>
            <Form.Field>
              <Form.Input placeholder='Téléphone' id='phone' fluid label='Téléphone' value={this.state.obj.phone} onChange={this.handleChange} />
            </Form.Field>
            <Tab menu={{ pointing: true }} panes={renderPanes(this.state.obj, this.handleChange)} />
          </Card.Description>
        </Card.Content>
      </Card>
    )
  }
}

export default IntroBlock



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/time_block.js